import React from 'react';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import CharacterCounter from '@/components/common/form/CharacterCounter';

export type NotesInputProps = Omit<TextFieldProps, 'variant'> & {
  label?: string;
  maxLength?: null | number;
  notes?: string;
  setNotes?: (note: string) => void;
  showCounter?: boolean;
};

export default function NotesInput({
  className = '',
  disabled = false,
  label = '',
  maxLength = null,
  notes = '',
  setNotes = () => {},
  showCounter = false,
  ...props
}: NotesInputProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNotes(event.target.value);
  };

  return (
    <TextField
      {...(className && { className })}
      variant="outlined"
      data-testid={`notes-input-${label}`}
      disabled={disabled}
      fullWidth
      helperText={
        !!maxLength &&
        showCounter && (
          <CharacterCounter
            count={notes.length}
            limit={maxLength}
            className="text-right"
          />
        )
      }
      inputProps={maxLength ? { maxLength } : {}}
      label={label}
      multiline
      onChange={handleChange}
      rows={4}
      value={notes}
      {...props}
    />
  );
}
